import { ApolloCache } from "@apollo/client"

import { Logger } from "shared/lib/Logger"
import {
  FloorTypename,
  ProjectChild,
  ProjectParentTypename,
  ProjectTypename,
  RoomTypename,
  isProjectProductPosition,
  isProjectRoom
} from "shared/types/Project"

import {
  FloorChildrenFragment,
  FloorChildrenFragmentDoc
} from "entities/floors/graphql/fragments.generated"
import {
  ProjectChildrenFragment,
  ProjectChildrenFragmentDoc
} from "entities/projects/graphql/fragments.generated"
import {
  RoomChildrenFragment,
  RoomChildrenFragmentDoc
} from "entities/rooms/graphql/fragments.generated"

export function updateProjectChildren({
  parentID,
  parentType,
  children,
  cache
}: {
  parentID: string
  parentType: ProjectParentTypename
  children: ProjectChild[]
  cache: ApolloCache<object>
}) {
  if (parentType === ProjectTypename) {
    const cacheId = cache.identify({
      id: parentID,
      __typename: ProjectTypename
    })
    if (!cacheId) return
    cache.updateFragment<ProjectChildrenFragment>(
      {
        fragment: ProjectChildrenFragmentDoc,
        fragmentName: "ProjectChildren",
        id: cacheId,
        optimistic: true
      },
      fragment => ({ ...fragment, children, __typename: ProjectTypename })
    )
  }
  if (parentType === RoomTypename) {
    const filteredChildren = children.filter(isProjectProductPosition)
    if (children.length !== filteredChildren.length) {
      Logger.error("Room children can only be product positions")
    }
    const cacheId = cache.identify({ id: parentID, __typename: RoomTypename })
    if (!cacheId) return
    cache.updateFragment<RoomChildrenFragment>(
      {
        fragment: RoomChildrenFragmentDoc,
        fragmentName: "RoomChildren",
        id: cacheId,
        optimistic: true
      },
      fragment => ({
        ...fragment,
        children: filteredChildren,
        __typename: RoomTypename
      })
    )
  }
  if (parentType === FloorTypename) {
    const filteredChildren = children.filter(isProjectRoom)
    if (children.length !== filteredChildren.length) {
      Logger.error("Room children can only be product positions")
    }
    const cacheId = cache.identify({ id: parentID, __typename: FloorTypename })
    if (!cacheId) return
    cache.updateFragment<FloorChildrenFragment>(
      {
        fragment: FloorChildrenFragmentDoc,
        fragmentName: "FloorChildren",
        id: cacheId,
        optimistic: true
      },
      fragment => ({
        ...fragment,
        children: filteredChildren,
        __typename: FloorTypename
      })
    )
  }
}
